module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=UG - Uganda.b022c7e8.svg";